import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Restores scroll position on navigation.
 *
 * A single-page app keeps the scroll offset across route changes, so following
 * a footer link from halfway down the provider page would otherwise land in the
 * middle of the privacy page. Same-page anchors (the `#join` CTAs) scroll to
 * their target instead.
 *
 * No smooth scrolling: it is nonessential motion, and spec section 11 says
 * avoid it.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }
    // Already at the top (and in jsdom, always): nothing to do.
    if (window.scrollX === 0 && window.scrollY === 0) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
